var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from "@mui/material";
import { VCLogoIcon } from "./VCLogoIcon";
import React from "react";
export function VCAppLogo(_a) {
    var { appName } = _a, props = __rest(_a, ["appName"]);
    return (React.createElement(Box, Object.assign({}, props),
        React.createElement(Box, { sx: { display: "flex", flexFlow: "row nowrap", alignItems: "center" } },
            React.createElement(VCLogoIcon, { width: "auto", height: "32", display: "block" }),
            appName && (React.createElement(Box, { sx: {
                    lineHeight: 1,
                    fontSize: "20px",
                    fontWeight: 900,
                    textTransform: "uppercase",
                    marginLeft: "8px",
                } }, appName)))));
}
//# sourceMappingURL=VCAppLogo.js.map